import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { pxToRem } from '@pc/shared';
import { SpinningLoaderComponent } from '@pc/spinning-loader';
import { PcButtonType } from './gradient-btn.enum';

@Component({
  selector: 'pc-gradient-btn',
  standalone: true,
  imports: [CommonModule, MatButtonModule, NgOptimizedImage, SpinningLoaderComponent],
  templateUrl: './gradient-btn.component.html',
  styleUrls: ['./gradient-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GradientBtnComponent {
  buttonType = input<keyof typeof PcButtonType>(PcButtonType.primary);
  text = input.required<string>();
  ariaText = input<string>();
  icon = input<string>();
  flipIcon = input<boolean>();
  invertIconColor = input(false);
  isDisabled = input(false);
  isLoading = input(false);
  isLoadingPrimaryColor = input(false);
  isDisabledRegularState = input(false);
  isTextImageReverseOrder = input(false);
  width = input(16);
  height = input(16);
  btnHeight = input<number | undefined>();
  btnPadding = input<number | undefined>();
  btnMinWidth = input<number | undefined>();
  isAnimated = input(false);
  innerHtmlButtonText = input<string>('');
  btnClicked = output();
  readonly pxToRem = pxToRem;
  readonly PcButtonType = PcButtonType;

  onClickHandler(): void {
    this.btnClicked.emit();
  }
}
